<template>
    <!-- need list headers  -->
    <div>
        
        <v-layout>
        <v-flex xs12>
            <hvh-freeze-data-table :class="{ disabled: false }" :headers='headers_' :items='modelData' :loading="false" />
        </v-flex>
        </v-layout>
    </div>
</template>


<script>

export default {
  props: ['modelData'],
    
    data() {
        var labels = {
            title: "Title",
            nctId: "NCT ID",
            role: "Role",
            startDate: "Start Date",
            studyType: "Study Type",
            phase: "Phase",
            therapeuticArea: "Therapeutic Area",
            enrollment: "Enrollment"
        };
        return {
            labels,
            
        };

    },
    computed: {
        headers_() {
            // if (Object.keys(this.filterHeaders).length > 0){
            //     this.filterHeaders.profileLink = {text:"Profile Link",route:"hcpProfile"}
            // }
            var headers = Object.keys(this.filterHeaders).length ? this.filterHeaders : this.labels;
            var retVal = Object.keys(headers)
                .map(key => ({
                    valueFnc: (item) => {try { return item[key]; } catch(e) { console.error(`Property - ${key}.`, e); }},
                    
                    // valueFnc: new Function('item', `try { return item.${key}; } catch(e) { console.error('Property - ${key}.', e); }`),
                    text: typeof(headers[key]) == 'string' ? headers[key] : headers[key].text,
                    routeObj: typeof(headers[key]) == 'object' ? headers[key] : {text:"",route:""} ,
                    routeParamsFnc: item => {try { return {runId:this.$route.params.runId, cohortId:1, npi:item.npi}; } catch(e) { console.error('Property - ${key}.', e); }},

                    // routeParamsFnc: new Function('item', `try { return {runId:${this.$route.params.runId}, cohortId:1, npi:item.npi}; } catch(e) { console.error('Property - ${key}.', e); }`),
                    link: typeof(headers[key]) == 'object' ? true: false,
                    sortable: false
                }));
            
            var link = retVal.filter(f => f.text == 'Profile Link')
            var nonLink = retVal.filter(f => f.text != 'Profile Link')

            retVal = [...link, ...nonLink]
            return retVal;
        },
        filterHeaders() {
            var headers = this.labels;
            return Object.keys(headers)
                .filter(key => headers[key])
                .reduce((acc, key) => {
                    
                    acc[key] = headers[key];
                    return acc;
                }, {});
        },
    },
    created() {
        
    },
    mounted() {
        this.modelData = this.modelData.sort(function(a,b){
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return new Date(b.startDate) - new Date(a.startDate);
        });
    },
    

}

</script>
<style scoped></style>